import React from 'react';
import { Chip, Tooltip } from '@material-ui/core';
import { useStyles } from "./chips.styles";

interface Item {
  name: string;
  icon?: string;
  alt: string;
}
interface ChipComponentProps {
  editable?: boolean;
  item: Item;
  onDeleteCallback: (value: any) => void;
  DeleteIcon: any;
}

const ChipComponent = (props: ChipComponentProps) => {
  const { editable, item, onDeleteCallback, DeleteIcon } = props;
  const classes = useStyles();

  const GetDelatableChips = () => {
    return (
      <Tooltip title={item.name} arrow>
        <Chip
          label={item.name}
          icon={<img src={item?.icon} alt={item.alt} />}
          onDelete={() => onDeleteCallback(item)}
          deleteIcon={<DeleteIcon />}
          className={`${classes.chips} ${classes.deletableChips}`}
        />
      </Tooltip>
    );
  };

  const GetUnDelatableChips = () => {
    return (
      <Tooltip title={item.name} arrow>
        <Chip
          label={item.name}
          icon={<img src={item?.icon} alt={item.alt} />}
          className={`${classes.chips} ${classes.UndeletableChips}`}
        />
      </Tooltip>
    );
  };

  return <>{editable ? <GetDelatableChips /> : <GetUnDelatableChips />}</>;
};

export default ChipComponent;